import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-brands',
    templateUrl: './brands.component.html',
    styleUrls: ['./brands.component.scss'],
    standalone: false
})
export class BrandsComponent implements OnInit {

  constructor() {
  }
  ngOnInit(): void {}
}
